import axios from "axios";
import router from "@/router";
import store from "@/store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import config from "./config";
import qs from "qs";
import { Toast, Notify } from "vant";
import { ANCHOR_DATA } from "@/constants/ROUTER_DATA";
export default function $axios(options) {
  const settings = Object.assign(
    {
      loading: options.loading,
      silent: options.silent || false
    },
    options || {}
  );

  return new Promise((resolve, reject) => {
    const instance = axios.create(config);

    const error = err => {
      // 关闭全屏loading
      settings.loading && Toast.clear();

      // 错误码
      Notify(
        `服务器错误(${settings.url
          .slice(1)
          .split("/")
          .join("_")
          .toLocaleUpperCase()}${
          err && err.response && err.response.status
            ? `_${err.response.status}`
            : ""
        })`
      );
      console.error("API", err);

      return Promise.reject(err);
    };

    // Add a request interceptor
    instance.interceptors.request.use(config => {
      // 是否加载全局loading
      settings.loading &&
        Toast.loading({
          forbidClick: true,
          duration: 0
        });

      // 判断是否存在token，如果存在的话，则每个http header都加上token
      store.getters.token &&
        (config.headers.common[ACCESS_TOKEN] = store.getters.token);

      //如为文件上传则不转为json格式
      if (config.url != "/v2/common/upload") {
        config.method.toLocaleLowerCase() === "post" &&
          (config.data = qs.stringify(config.data));
      }
      return config;
    }, error);

    // Add a response interceptor
    instance.interceptors.response.use(response => {
      // 关闭全屏loading
      settings.loading && Toast.clear();
      // token 不存在 / 登录超时
      if (response.data.rcode === 2017) {
        store.dispatch("Logout").then(() => {
          //离开页面
          store.dispatch("SetLeave", true);
          router.replace({
            path: ANCHOR_DATA.login.path,
            query: {
              redirect: router.history.current.fullPath
            }
          });
        });
      }

      if (response.data.rcode !== 0) {
        if (
          !settings.silent ||
          (settings.silent.length &&
            settings.silent.indexOf(response.data.rcode) === -1)
        ) {
          Toast.fail(response.data.rdesc);
        }
        return response.data;
      }
      return response.data;
    }, error);

    instance(options)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}
